import _import from '../_import'

export default [{
  path: '/projects',
  name: 'project-list',
  component: _import('project/ProjectList'),
}]
